export const firebaseConfig = {
  'apiKey': 'AIzaSyCAuhRRp-E7-ZTG9jOgy-rXzGY3_41-NNk',
  'authDomain': 'marketplace-dev-98ce8.firebaseapp.com',
  'projectId': 'marketplace-dev-98ce8',
  'storageBucket': 'marketplace-dev-98ce8.firebasestorage.app',
  'messagingSenderId': '535113352168',
  'appId': '1:535113352168:web:367c3ed48e61e366535a5d',
  'measurementId': 'G-RMXCB2BK5K',
};

export const environment = {
  apiUrl: 'https://us-central1-readymaster-development.cloudfunctions.net',
  production: false,
  projectId: 'C7jkuZBXmOhmpYSNjMjd',
  auth: {
    url: 'https://development-oauth.theplay.network',
  },
  gtag_measurement_id: 'G-BEX7CG330K',
  forteUrl: 'https://dev-forte-payments-cdn.pti-dev.cloud/forte-payments-widget.js',
  firebaseStorageUrl:
    'https://firebasestorage.googleapis.com/v0/b/readymaster-development.appspot.com/',
  firebaseConfig,
  firebaseMasterConfig: {
    apiKey: 'AIzaSyBJ212bey2FAfhN-JZpw4eHi8loM7XUdW4',
    authDomain: 'readymaster-development.firebaseapp.com',
    databaseURL: 'https://readymaster-development-default-rtdb.firebaseio.com',
    projectId: 'readymaster-development',
    storageBucket: 'readymaster-development.appspot.com',
    messagingSenderId: '767053156338',
    appId: '1:767053156338:web:480511463f746e3664a56b',
    measurementId: 'G-BSGX9EY4TW',
  },
};
